
import { Options, prop, Vue } from "vue-class-component";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ModalMessageEntities } from "@/domain/entities/MainApp";
import { AuthController } from "@/app/ui/controllers/AuthController";
import debounce from "lodash/debounce";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { recaptchaV3 } from "@/app/infrastructures/misc/common-library/RecaptchaV3";
import {
  EditPasswordApiRequest,
  OtpRequest
} from "@/data/payload/api/AuthRequest";
import { TokenVerificationAccountEntities } from "@/domain/entities/Auth";
import { FlagsOtp } from "@/feature-flags/flags-otp";
import OtpDisclaimer from "../../components/modal-otp/otp-disclaimer.vue";

class Props {
  modelValue = prop<boolean>({
    type: Boolean,
    default: false
  });
  message = prop<string>({
    type: String,
    default: ""
  });
}

@Options({
  emits: ["update:modelValue", "open-otp"],
  components: {
    OtpDisclaimer
  }
})
export default class ModalChangePassword extends Vue.with(Props) {
  onReset() {
    this.oldPassword = "";
    AuthController.setErrorPassword(false);

    this.newPassword = "";
    this.confirmationNewPassword = "";

    this.passwordType = "password";
    this.confirmationNewPasswordType = "password";

    this.errorMessageOtp = "";
  }
  onClose() {
    this.toggleModalChangePassword(false);
    this.onReset();
  }

  toggleModalChangePassword(bool: boolean) {
    this.$emit("update:modelValue", bool);
  }

  // logic confirmation change password
  get isFormValid() {
    return (
      this.oldPassword !== this.newPassword &&
      this.confirmationNewPassword &&
      this.newPassword &&
      this.confirmationNewPasswordInvalid === "" &&
      this.newPasswordInvalid === "" &&
      this.isOldPasswordValid 
    );
  }
  confirmationChangePassword() {
    this.toggleModalChangePassword(false);
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        title: this.$t("profile.changePassword.title"),
        message: this.$t("profile.changePassword.msg"),
        textCancel: this.$t("Kembali"),
        textSuccess: this.$t("Simpan"),
        onSubmit: () => {
          this.errorMessageOtp = "";
          this.otpData = new TokenVerificationAccountEntities();

          if (FlagsOtp.otp_enable_change_password.isEnabled()) {
            this.verifyOtp();
            return;
          }

          this.submitChangePassword();
        },
        onClose: () => {
          this.toggleModalChangePassword(true);
          MainAppController.closeMessageModal();
        },
        image: "are-you-sure"
      })
    );
  }
  errorMessageOtp = "";
  otpData = new TokenVerificationAccountEntities();
  async verifyOtp() {
    try {
      const captchaToken = await recaptchaV3.executeRecaptcha(
        "otp_enable_change_password"
      );

      MainAppController.closeMessageModal();
      MainAppController.showLoading();

      const action = "change_password";
      this.otpData = await AuthController.requestOtp(
        new OtpRequest({
          password: this.oldPassword,
          captchaToken,
          action
        })
      );

      this.$emit(
        "open-otp",
        new TokenVerificationAccountEntities({
          ...this.otpData,
          password: this.oldPassword,
          action
        })
      );
    } catch (error) {
      this.errorMessageOtp = (error as any)?.response?.data?.message?.id;
      this.$emit("error-request-otp");
    } finally {
      MainAppController.closeLoading();
    }
  }
  async submitChangePassword(otp = "", token = "") {
    MainAppController.closeMessageModal();
    const resp = await AuthController.editPassword({
      payload: new EditPasswordApiRequest({
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        token: token || this.otpData.token,
        otp,
        version: "v2"
      }),
      callback: this.onReset
    });
    if (resp) {
      this.modalSuccessChangePassword();
      this.onClose();
    }

    return resp;
  }

  modalSuccessChangePassword() {
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        title: this.$t("profile.aturUlang"),
        message: this.$t("profile.pesanAturUlang"),
        textSuccess: "OKE",
        onSubmit: () => MainAppController.closeMessageModal(),
        image: "ill_badge_success",
        isButtonFull: true
      })
    );
  }

  // snackbar success change password
  openSnackbar() {
    MainAppController.setSnackbarMessage(
      this.$t("Perubahan password berhasil !")
    );
    MainAppController.setSnackbar(true);
  }

  // input field password
  newPassword = "";
  passwordType = "password";
  showPassword() {
    if (this.passwordType === "password") {
      this.passwordType = "text";
    } else {
      this.passwordType = "password";
    }
  }
  get newPasswordInvalid() {
    if (this.newPassword === "") {
      return "";
    }
    if (this.newPassword.length < 8) {
      return this.$t("Password harus berisi minimal 8 karakter");
    }
    return "";
  }

  // input field confirmation password
  confirmationNewPassword = "";
  confirmationNewPasswordType = "password";
  showConfirmationPassword() {
    if (this.confirmationNewPasswordType === "password") {
      this.confirmationNewPasswordType = "text";
    } else {
      this.confirmationNewPasswordType = "password";
    }
  }
  get confirmationNewPasswordInvalid() {
    if (this.confirmationNewPassword === "") {
      return "";
    }
    if (this.confirmationNewPassword !== this.newPassword) {
      return this.$t("Password baru tidak sama");
    }
    return "";
  }

  // input field old password
  oldPassword = "";
  oldPasswordType = "password";
  showOldPassword() {
    if (this.oldPasswordType === "password") {
      this.oldPasswordType = "text";
    } else {
      this.oldPasswordType = "password";
    }
  }
  get isWrongOldPassword() {
    return AuthController.isErrorWrongPassword;
  }
  isOldPasswordValid = false;
  validateOldPassword = debounce(async (e: any) => {
    const value = e.target.value;
    if (value.length === 0) {
      AuthController.setErrorPassword(false);
      this.isOldPasswordValid = false;
      return;
    }
    this.isOldPasswordValid = await AuthController._onCheckPassword({
      email: AccountController.accountData.username,
      password: e.target.value
    });
  }, 500);

  FlagsOtp = FlagsOtp;
}
